import { Tooltip } from "antd";
import Matiers from "components/matiers";
import React from "react";
import { ApercueQuiz } from "../../apercueQuiz";
import ChallengeSubmited from "../../challengeSubmitted";
import style from "../assets/style.module.css";
import { UpdateDate } from "../utils/updateDate/UpdateDate";

interface CardMenuInterface {
  data: any;
  someClasseDataNeeded: any;
  handler: any;
  setDrawerConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  setTempsChallenge: React.Dispatch<React.SetStateAction<number>>;
}
export const Card: React.FC<CardMenuInterface> = (props) => {
  return (
    <div className={`${style.Card} ${style.relative}`}>
      <div className={style.__card__header}>
        <UpdateDate date={props.data?.updatedAt} />
        <Matiers
          className={style.__matieres}
          cours={props?.data?.course?.title}
          level={props?.data?.course?.level?.title}
        />
      </div>

      <h4 className={style.__card__title} style={{ textAlign: "center", marginLeft: "20px", marginRight: "20px" }}>{props?.data?.chapterId?.title}</h4>

      <div className={style.__card__body}>
        <h4 className={style.__card__title} style={{ paddingLeft: "10px", paddingRight: "10px" }}>
          <Tooltip title={props?.data?.title}>
            {props?.data?.title}
          </Tooltip>
        </h4>

        <div
          style={{
            fontSize: "14px",
            fontWeight: "500",
            color: "black",
          }}
        >
          {props.data?.duration}mins - {props.data?.quizzLevel}
        </div>
      </div>

      <div className={style.__card__footer}>
        <ApercueQuiz data={props.data?.questions} title={props.data?.title} />
        <ChallengeSubmited
          handler={props.handler}
          quizz={props.data?._id}
          title={props.data?.title}
          setDrawerConfirm={props.setDrawerConfirm}
          setTempsChallenge={props.setTempsChallenge}
        />
      </div>
    </div>
  );
};

export default Card;
